import { faceSearchService } from "../_services/face.search.service";

export const faceSearchAction = {
  saveFaceSearchAllocation,
  getFaceSearchAllocation,
  updateFaceSearchAllocation,
  uploadFaceSearchImage,
  createFindFaceSearch,
  getFindFaceSearchCityWise,
  getFindFaceSearchId,
  getFaceSearchDetails,
};

function saveFaceSearchAllocation(values) {
  return faceSearchService.saveFaceSearchAllocation(values);
}
function getFaceSearchAllocation() {
  return faceSearchService.getFaceSearchAllocation();
}
function updateFaceSearchAllocation(values) {
  return faceSearchService.updateFaceSearchAllocation(values);
}
function citieswiseFaceSearchAllocation(userid) {
  return faceSearchService.citieswiseFaceSearchAllocation(userid);
}
function uploadFaceSearchImage(file) {
  return faceSearchService.uploadFaceSearchImage(file);
}
function createFindFaceSearch(values) {
  return faceSearchService.createFindFaceSearch(values);
}
function getFindFaceSearchCityWise(id) {
  return faceSearchService.getFindFaceSearchCityWise(id);
}
function getFindFaceSearchId(id) {
  return faceSearchService.getFindFaceSearchId(id);
}
function getFaceSearchDetails(id) {
  return faceSearchService.getFaceSearchDetails(id);
}
